import { Scene, PerspectiveCamera, PMREMGenerator, Color } from 'three/webgpu'
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js'

export default class BaseScene extends Scene {
	static defaults = {
		fov: 45,
		near: 0.1,
		far: 100,
		distance: 3,
		environmentIntensity: 0.3,
		background: null,
		sheet: null,
		project: null,
	}

	constructor(renderer, options = {}) {
		super()
		this.options = { ...BaseScene.defaults, ...this.constructor.defaults, ...options }
		this.renderer = renderer
		this.sheet = this.options.sheet
		this.project = this.options.project
		this.objects = []
	}

	init(width, height) {
		this.#setupEnvironment()
		this.#setupCamera(width, height)
		this.addObjects()
	}

	addObjects() {}

	addObject(object) {
		this.objects.push(object)
		this.add(object)
		object.bindStudio?.(this.sheet)

		return object
	}

	removeObject(object) {
		const index = this.objects.indexOf(object)
		if (index === -1) return

		this.objects.splice(index, 1)
		this.remove(object)
		object.dispose()
	}

	#setupEnvironment() {
		const environment = new RoomEnvironment()
		const pmrem = new PMREMGenerator(this.renderer)

		this.background = this.options.background === null ? null : new Color(this.options.background)
		this.envMap = pmrem.fromScene(environment).texture
		this.environment = this.envMap
		this.environmentIntensity = this.options.environmentIntensity

		environment.dispose()
		pmrem.dispose()
	}

	#setupCamera(width, height) {
		const { fov, near, far, distance } = this.options

		this.camera = new PerspectiveCamera(fov, width / height, near, far)
		this.camera.position.z = distance
	}

	update(delta, elapsed) {
		for (let i = 0; i < this.objects.length; i++) {
			this.objects[i].update(delta, elapsed)
		}
	}

	onPageChange() {}

	onResize(width, height) {
		this.camera.aspect = width / height
		this.camera.updateProjectionMatrix()

		for (let i = 0; i < this.objects.length; i++) {
			this.objects[i].onResize?.(width, height)
		}
	}

	dispose() {
		this.envMap.dispose()

		for (let i = 0; i < this.objects.length; i++) {
			this.objects[i].dispose()
		}

		this.objects.length = 0
	}
}
